import React, { useContext, useState, useEffect } from 'react';
import 'twin.macro';
import { Link } from 'react-router-dom';
import { PlaylistsContext } from '../../context';
import { DropDown, DropDownItem } from '../../dropdown';
import { ListAddIcon, PlusIcon, ArrowIcon, TimesIcon } from 'icons';
import { Input } from '../../form';
import { Small } from '../../text';
import { Pill } from '../../pill';
import { Icon } from '../../icon';
import { PLAYLIST_PATH } from '../../../data/';

export const PlaylistAddItem = ({ itemId, isMobile }) => {
  const { currentAuthorId, playlistItems, loading, addItemToPlaylists, createNewPlaylist } =
    useContext(PlaylistsContext);

  const [listItems, setListItems] = useState([]);
  const [filterValue, setFilterValue] = useState('');
  const listLength = playlistItems.length;
  const maxNumLists = 3;
  const filterActive = filterValue !== '';

  const handleSearch = () => {
    const filteredData = playlistItems.filter((value) => {
      const searchStr = filterValue.toLowerCase();
      return value.title.toLowerCase().includes(searchStr);
    });
    setListItems(filteredData === 0 ? playlistItems : filteredData);
  };

  useEffect(() => {
    handleSearch();
  }, [filterValue]);

  useEffect(() => {
    filterValue === '' ? setListItems(playlistItems) : handleSearch();
  }, [playlistItems]);

  return (
    <>
      {!loading && (
        <>
          {playlistItems && playlistItems.length === 0 && <></>}
          {playlistItems && playlistItems.length > 0 && (
            <DropDown
              label='toevoegen'
              hideLabel={isMobile}
              iconProps={{ Type: ListAddIcon }}
              buttonProps={{ secondary: true }}
            >
              <DropDownItem>
                <div tw='relative'>
                  <Input
                    id='filter'
                    placeholder='filter'
                    value={filterValue}
                    onChange={(e) => {
                      setFilterValue(e.target.value);
                    }}
                    tw='mb-0 pr-6'
                  />
                  {filterActive && (
                    <Icon
                      Type={TimesIcon}
                      onClick={() => setFilterValue('')}
                      size='medium'
                      tw='absolute top-2 right-1 hover:opacity-60'
                    />
                  )}
                </div>
              </DropDownItem>

              {(listLength === 0 || (filterActive && listItems.length === 0)) && (
                <Small>Geen resultaten</Small>
              )}
              {listItems.slice(0, maxNumLists).map((item, index) => {
                const playlistPosts = item.posts ? Object.values(item.posts) : [];
                const currentItemId = Number(itemId.split('_')[0]);
                const PlaylistContainsItem = playlistPosts.indexOf(currentItemId) > -1;
                const isPrivateList = item && item.private;
                return (
                  <DropDownItem
                    key={index}
                    label={
                      <>
                        <Pill success={!isPrivateList} danger={isPrivateList} tw='mr-2' />
                        {item.title}
                      </>
                    }
                    selectedValue={PlaylistContainsItem}
                    onClick={() =>
                      addItemToPlaylists({ playlistId: item.id, itemId: currentItemId })
                    }
                  />
                );
              })}
              {listLength > maxNumLists && !filterActive && (
                <DropDownItem>
                  <Small tw='mx-auto'>
                    nog {listLength - maxNumLists} andere lijst
                    {listLength - maxNumLists === 1 ? '' : 'en'}
                  </Small>
                </DropDownItem>
              )}

              <DropDownItem
                tw='border-t flex justify-between w-full border-dark pt-2'
                IconType={PlusIcon}
                iconColor='icons'
                onClick={() =>
                  createNewPlaylist({
                    title: 'Nieuwe playlist',
                    description: '',
                    isPrivate: true,
                    goToEdit: false,
                  })
                }
                className='group text-light'
              >
                Nieuwe playlist
              </DropDownItem>
              <DropDownItem
                tw='border-t flex justify-between w-full border-dark pt-2'
                IconType={ArrowIcon}
                iconColor='icons'
                iconRotation='90'
                className='group text-light'
              >
                <Link to={`${PLAYLIST_PATH.userPlaylists}/${currentAuthorId}`}>
                  Bekijk afspeellijsten
                </Link>
              </DropDownItem>
            </DropDown>
          )}
        </>
      )}
    </>
  );
};
